export interface PurchaseOrderTemplate {
  id: string;
  name: string;
  templateCompanyName: string;
  templateLogo?: string | null;
  logoBase64?: string | null;
  layoutType: string;
  colorScheme: {
    primary: string;
    secondary: string;
    text: string;
    background: string;
  };
  fontFamily: string;
  isDefault: boolean;
}

export interface PurchaseOrder {
  id: string;
  poNumber: string;
  vendorId: string;
  templateId?: string | null;
  orderDate: string;
  expectedDeliveryDate?: string | null;
  status: PurchaseOrderStatus;
  subtotal: number;
  taxAmount: number;
  shippingCost: number;
  total: number;
  notes?: string | null;
  termsAndConditions?: string | null;
  companyId: string;
  createdAt: string;
  updatedAt: string;
  vendor?: {
    id: string;
    name: string;
    email?: string;
    phone?: string;
  };
  template?: PurchaseOrderTemplate | null;
  items?: PurchaseOrderItem[];
  receipts?: any[];
  bills?: any[];
  _count?: {
    receipts: number;
    bills: number;
  };
}

export interface PurchaseOrderItem {
  id: string;
  purchaseOrderId: string;
  productId: string;
  description: string;
  quantity: number;
  receivedQuantity: number;
  rate: number;
  amount: number;
  taxRate?: number | null;
  taxAmount?: number;
  createdAt: string;
  updatedAt: string;
  product?: {
    id: string;
    name: string;
    sku: string;
    isSerialized: boolean;
  };
  receiptItems?: any[];
}

export type PurchaseOrderStatus =
  | 'DRAFT'
  | 'ORDERED'
  | 'PARTIALLY_RECEIVED'
  | 'RECEIVED'
  | 'CANCELLED';

export interface CreatePurchaseOrderData {
  vendorId: string;
  templateId?: string;
  orderDate?: string;
  expectedDeliveryDate?: string;
  items: CreatePurchaseOrderItemData[];
  notes?: string;
  termsAndConditions?: string;
  shippingCost?: number;
}

export interface CreatePurchaseOrderItemData {
  productId: string;
  description: string;
  quantity: number;
  rate: number;
  taxRate?: number | null;
}

export interface UpdatePurchaseOrderData extends Partial<CreatePurchaseOrderData> {
  status?: PurchaseOrderStatus;
}

export interface PurchaseOrderFilters {
  page?: number;
  limit?: number;
  vendorId?: string;
  search?: string;
  status?: PurchaseOrderStatus;
}

export interface PurchaseOrdersResponse {
  purchaseOrders: PurchaseOrder[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
  };
}

export const PURCHASE_ORDER_STATUS_LABELS: Record<PurchaseOrderStatus, string> = {
  DRAFT: 'Draft',
  ORDERED: 'Ordered',
  PARTIALLY_RECEIVED: 'Partially Received',
  RECEIVED: 'Received',
  CANCELLED: 'Cancelled'
};

export const PURCHASE_ORDER_STATUS_COLORS: Record<PurchaseOrderStatus, string> = {
  DRAFT: 'bg-gray-100 text-gray-800',
  ORDERED: 'bg-blue-100 text-blue-800',
  PARTIALLY_RECEIVED: 'bg-yellow-100 text-yellow-800',
  RECEIVED: 'bg-green-100 text-green-800',
  CANCELLED: 'bg-red-100 text-red-800'
};
